import type { TFunction } from 'i18next';

import type { PercentageBarItem } from '@/components/organisms/PercentageBars';
import type { LaksvelParameterData, WoundsData } from '@/domain/smoltReport';

import type { WelfareLineChartDataset } from '../components/WelfareLineChart';
import { WELFARE_CHART_COLORS } from '../components/WelfareLineChart';

export function mapWoundsDevelopmentDatasets(
    woundsData: WoundsData,
    t: TFunction
): WelfareLineChartDataset[] {
    return [
        {
            label: t('smoltReport.detailView.woundsTypeAcute'),
            color: WELFARE_CHART_COLORS.red,
            data: woundsData.development.map((d) => ({
                day: d.day,
                value: d.acute != null ? d.acute * 100 : null,
            })),
        },
        {
            label: t('smoltReport.detailView.woundsTypeHealing'),
            color: WELFARE_CHART_COLORS.riverside,
            data: woundsData.development.map((d) => ({
                day: d.day,
                value: d.healing != null ? d.healing * 100 : null,
            })),
        },
    ];
}

export function mapWoundsTypeItems(woundsData: WoundsData, t: TFunction): PercentageBarItem[] {
    return [
        {
            label: t('smoltReport.detailView.woundsTypeAcute'),
            value: woundsData.acute != null ? woundsData.acute * 100 : null,
            color: WELFARE_CHART_COLORS.red,
        },
        {
            label: t('smoltReport.detailView.woundsTypeHealing'),
            value: woundsData.healing != null ? woundsData.healing * 100 : null,
            color: WELFARE_CHART_COLORS.riverside,
        },
    ];
}

export function mapLaksvelDevelopmentDatasets(
    laksvelData: LaksvelParameterData,
    t: TFunction
): WelfareLineChartDataset[] {
    return [
        {
            label: t('smoltReport.detailView.laksvelScore1'),
            color: WELFARE_CHART_COLORS.yellow,
            data: laksvelData.development.map((d) => ({ day: d.day, value: d.score1 })),
        },
        {
            label: t('smoltReport.detailView.laksvelScore2'),
            color: WELFARE_CHART_COLORS.orange,
            data: laksvelData.development.map((d) => ({ day: d.day, value: d.score2 })),
        },
        {
            label: t('smoltReport.detailView.laksvelScore3'),
            color: WELFARE_CHART_COLORS.red,
            data: laksvelData.development.map((d) => ({ day: d.day, value: d.score3 })),
        },
    ];
}

export function mapLaksvelScoreItems(
    laksvelData: LaksvelParameterData,
    t: TFunction
): PercentageBarItem[] {
    return [
        {
            label: t('smoltReport.detailView.laksvelScore1'),
            value: laksvelData.score1 ?? null,
            color: WELFARE_CHART_COLORS.yellow,
        },
        {
            label: t('smoltReport.detailView.laksvelScore2'),
            value: laksvelData.score2 ?? null,
            color: WELFARE_CHART_COLORS.orange,
        },
        {
            label: t('smoltReport.detailView.laksvelScore3'),
            value: laksvelData.score3 ?? null,
            color: WELFARE_CHART_COLORS.red,
        },
    ];
}
